import React, { useEffect, useState } from 'react';
import { X, Sparkles, Copy, Check } from 'lucide-react';

const STORAGE_KEY = 'rl_promo_dismissed_v1';

export default function PromoStrip({ code = 'RARE10', percent = 10 }) {
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try { if (!localStorage.getItem(STORAGE_KEY)) setVisible(true); } catch (e) { setVisible(true); }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  };

  const copy = () => {
    try {
      navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {}
  };

  if (!visible) return null;

  return (
    <div className="relative bg-brand-gold text-brand-dark text-xs sm:text-sm rl-print-hide">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 sm:gap-3 pr-10 sm:pr-12">
        <Sparkles size={14} aria-hidden="true" className="hidden sm:inline flex-shrink-0" />
        <span className="text-center leading-snug">
          <strong>First order?</strong> Enjoy {percent}% off with code{' '}
          <button
            type="button"
            onClick={copy}
            className="inline-flex items-center gap-1 font-semibold underline underline-offset-2 hover:no-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-dark rounded"
            aria-label={`Copy coupon code ${code}`}
          >
            {code}
            {copied ? <Check size={12} aria-hidden="true" /> : <Copy size={12} aria-hidden="true" />}
          </button>
        </span>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss promo"
        className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full text-brand-dark/70 hover:text-brand-dark hover:bg-brand-dark/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-dark"
      >
        <X size={14} aria-hidden="true" />
      </button>
    </div>
  );
}
